import { Injectable } from '@angular/core';
import { PREFIX } from './../interfaces/Prefix.interface';
import { MasterRepo } from './../repositories/masterRepo.service';
import { TrnProd } from './../interfaces/TrnMain';
import { TrnMain } from './../interfaces/TrnMain';
// import { MockMasterRepo } from "./../repositories/MockmasterRepo.service";
import { IDivision } from './../interfaces/commonInterface.interface';

import { AuthService } from './../services/permission/index';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
// import { Subscriber } from 'rxjs/Subscriber';
import { BehaviorSubject } from 'rxjs';
import { TAcList } from '../interfaces/Account.interface';
import { VoucherTypeEnum } from '../interfaces/index';
import * as _ from 'lodash';
import { SettingService } from '../services/setting.service';
@Injectable()
export class TransactionService {
  TrnMainObj: TrnMain = <TrnMain>{};
  Warehouse: string = '';
  pageHeading: string = '';
  prefix: PREFIX = <PREFIX>{};
  division: IDivision = <IDivision>{};
  saveDisable: boolean = false;
  differenceAmount: number = 0;
  salesMode: string = '';
  cnMode: string = '';
  warrentyUpToDate!: Date;
  warrentyVchrList: any[] = [];
  buttonHeading: string = 'Reference No';
  accountListSubject: BehaviorSubject<TAcList[]> = new BehaviorSubject<
    TAcList[]
  >([]);
  accountListObersver$: Observable<TAcList[]> =
    this.accountListSubject.asObservable();
  TableAcHeader: string = 'Description';
  prodListMode!: ProdListMode;
  prodDisableSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  prodDisable$: Observable<boolean> = this.prodDisableSubject.asObservable();
  cnReturnedProdList!: TrnProd[];
  referenceNoSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
  referenceNo$: Observable<string> = this.referenceNoSubject.asObservable();
  public PrintStuffSubject: BehaviorSubject<any> = new BehaviorSubject<any>({});
  public PrintStuff$: Observable<any> = this.PrintStuffSubject.asObservable();
  constructor(
    private masterService: MasterRepo,
    private setting: SettingService
  ) {
    // this.masterService.getProductItemList().subscribe();
  }
  trnmainBehavior: BehaviorSubject<TrnMain> = new BehaviorSubject(<TrnMain>{});
  loadDataObservable: Observable<TrnMain> = this.trnmainBehavior.asObservable();
  PMode: string = ''; //p for party mode and c for customer mode
  MaxTotalAmountLimit: number = 5000;
  DefaultCustomerAc: string = '';
  SettlementNo: any;
  INVMAIN: any;
  loadData(VCHR: string, division: string, phiscalid: string) {
    //return new Observable((observer: Subscriber<TrnMain>) => {
    this.masterService.LoadTransaction(VCHR, division, phiscalid).subscribe(
      (data: any) => {
        if (data.status == 'ok') {
          console.log('serviceTransaction', data.result);
          this.TrnMainObj = data.result;
          this.Warehouse = this.TrnMainObj.WAREHOUSE;
          if (
            !this.Warehouse &&
            this.TrnMainObj.ProdList &&
            this.TrnMainObj.ProdList.length > 0
          ) {
            this.Warehouse = this.TrnMainObj.ProdList[0].WAREHOUSE;
          }
          console.log({
            onLoadWarehouse: this.Warehouse,
            trnmain: this.TrnMainObj,
          });
          this.TrnMainObj.TrntranList.forEach((trntran) => {
            if (trntran.A_ACID) {
              this.masterService.accountList$
                .pipe(
                  map((aclist: any) => {
                    return aclist.find((x: any) => x.ACID == trntran.A_ACID);
                  })
                )
                .subscribe((ac: any) => {
                  if (ac) {
                    trntran.AccountItem = ac;
                  }

                  //console.log({ trntranService: trntran.AccountItem });
                });
            }
          });
          console.log({ serviceData: data.result });
          this.trnmainBehavior.next(this.TrnMainObj);
        }
      },
      (error: any) => {
        console.log({ 'Load Data Error': error });
        this.trnmainBehavior.complete();
      },
      () => this.trnmainBehavior.complete()
    );
    //});
  }

  getItemType() {
    return [
      { label: 'FOC', value: 'FOC' },
      { label: 'FAULTY', value: 'FALUTY' },
    ];
  }

  getReceivedType() {
    return [
      { label: 'DAMAGED', value: 'DAMAGED' },
      { label: 'MISSING', value: 'MISSING' },
    ];
  }

  CalculateNormal(
    TrnProdObj: TrnProd,
    ServiceTaxRate = this.setting.appSetting.ServiceTaxRate || 0,
    VatRate = this.setting.appSetting.VATRate || 0,
    calcuteDiscount = 0
  ) {
    console.log({ Trnprodobj: TrnProdObj });
    TrnProdObj.AMOUNT = TrnProdObj.Quantity * TrnProdObj.RATE;
    console.log({ Trnprodobj2: TrnProdObj });
    if (this.setting.appSetting.ENABLEMULTICURRENCY == 1) {
      console.log('currenry');
      TrnProdObj.NCRATE = this.curencyConvert(TrnProdObj.RATE);
      TrnProdObj.EXRATE = this.TrnMainObj.EXRATE;
      TrnProdObj.AMOUNT = TrnProdObj.Quantity * TrnProdObj.NCRATE;
    }
    if (calcuteDiscount == 1) {
      if (TrnProdObj.IDIS != null) {
        if (TrnProdObj.IDIS.indexOf('%') < 0) {
          TrnProdObj.INDDISCOUNT = parseFloat(TrnProdObj.IDIS);
        } else {
          var dis = parseFloat(TrnProdObj.IDIS.replace('%', '').trim());
          dis = dis / 100;
          TrnProdObj.INDDISCOUNT = TrnProdObj.AMOUNT * dis;
        }
      }
    }
    TrnProdObj.DISCOUNT =
      this.nullToZeroConverter(TrnProdObj.INDDISCOUNT) +
      this.nullToZeroConverter(TrnProdObj.PROMOTION) +
      this.nullToZeroConverter(TrnProdObj.LOYALTY);
    if (this.nullToZeroConverter(TrnProdObj.ISSERVICECHARGE) == 1) {
      TrnProdObj.SERVICETAX =
        (TrnProdObj.AMOUNT - TrnProdObj.DISCOUNT) * ServiceTaxRate;
    }
    if (TrnProdObj.ISVAT == 1) {
      TrnProdObj.TAXABLE =
        TrnProdObj.AMOUNT -
        TrnProdObj.DISCOUNT +
        this.nullToZeroConverter(TrnProdObj.SERVICETAX);
      TrnProdObj.NONTAXABLE = 0;
      TrnProdObj.VAT = TrnProdObj.TAXABLE * VatRate;
    } else {
      TrnProdObj.TAXABLE = 0;
      TrnProdObj.NONTAXABLE =
        TrnProdObj.AMOUNT -
        TrnProdObj.DISCOUNT +
        this.nullToZeroConverter(TrnProdObj.SERVICETAX);
    }
    TrnProdObj.NETAMOUNT =
      TrnProdObj.TAXABLE + TrnProdObj.NONTAXABLE + TrnProdObj.VAT;
    return TrnProdObj;
  }
  curencyConvert(rate: any) {
    var C = this.masterService.Currencies.find(
      (x) => x.CURNAME == this.TrnMainObj.FCurrency
    );
    console.log('currency', C);
    if (C != null) {
      return C.EXRATE * rate;
    } else return rate;
  }

  ReCalculateBill(
    TrnMainObj: TrnMain,
    ServiceTaxRate = this.setting.appSetting.ServiceTaxRate || 0,
    VatRate = this.setting.appSetting.VATRate || 0
  ) {
    var inType: number[] = [1, 4, 5, 8, 14, 16, 13];
    var outType: number[] = [2, 3, 6, 7, 15, 21, 26];
    var tranType: string;
    if (_.includes(inType, TrnMainObj.VoucherType, 0)) {
      tranType = 'in';
    } else if (_.includes(outType, TrnMainObj.VoucherType, 0)) {
      tranType = 'out';
    }
    TrnMainObj.TOTAMNT = 0;
    TrnMainObj.TOTALINDDISCOUNT = 0;
    TrnMainObj.TOTALLOYALTY = 0;
    TrnMainObj.TOTALPROMOTION = 0;
    TrnMainObj.DCAMNT = 0;
    TrnMainObj.ServiceCharge = 0;
    TrnMainObj.TAXABLE = 0;
    TrnMainObj.NONTAXABLE = 0;
    TrnMainObj.VATAMNT = 0;
    TrnMainObj.NETWITHOUTROUNDOFF = 0;
    // TrnMainObj.ProdList.filter(x => x.ADDTIONALROW == 0 || x.ADDTIONALROW == null).forEach(x => { TrnMainObj.TOTAMNT += x.AMOUNT; });
    //calculating flat discount. If GblReplaceIndividualWithFlat=1 or 0
    var i: number = 0;
    var amt: number = 0;

    TrnMainObj.ProdList.forEach((prod) => {
      i++;
      prod.SNO = i;
      amt +=
        prod.AMOUNT -
        this.nullToZeroConverter(prod.INDDISCOUNT) -
        this.nullToZeroConverter(prod.PROMOTION) -
        this.nullToZeroConverter(prod.LOYALTY);
      if (TrnMainObj.ReplaceIndividualWithFlatDiscount == 1) {
        if (TrnMainObj.TOTALFLATDISCOUNT != 0) {
          prod.INDDISCOUNT = 0;
        }
      }
      if (amt == 0) {
        prod.FLATDISCOUNT = 0;
      } else {
        prod.FLATDISCOUNT =
          (prod.AMOUNT -
            this.nullToZeroConverter(prod.INDDISCOUNT) -
            this.nullToZeroConverter(prod.PROMOTION) -
            this.nullToZeroConverter(prod.LOYALTY)) *
          (this.nullToZeroConverter(TrnMainObj.TOTALFLATDISCOUNT) / amt);
      }

      prod.DISCOUNT =
        this.nullToZeroConverter(prod.INDDISCOUNT) +
        this.nullToZeroConverter(prod.FLATDISCOUNT) +
        this.nullToZeroConverter(prod.PROMOTION) +
        this.nullToZeroConverter(prod.LOYALTY);
      if (prod.ISSERVICECHARGE == 1) {
        prod.SERVICETAX = (prod.AMOUNT - prod.DISCOUNT) * ServiceTaxRate;
      }
      if (prod.ISVAT == 1) {
        prod.TAXABLE =
          prod.AMOUNT -
          prod.DISCOUNT +
          this.nullToZeroConverter(prod.SERVICETAX);
        prod.VAT = prod.TAXABLE * VatRate;
        prod.NONTAXABLE = 0;
        prod.NCRATE = prod.RATE * prod.EXRATE;
        // if (prod.REALQTY_IN == 0)
        // { prod.NCRATE = prod.PRATE; }
        // else
        // { prod.NCRATE = prod.TAXABLE / this.nullToZeroConverter(prod.REALQTY_IN); }
      } else {
        prod.TAXABLE = 0;
        prod.VAT = 0;
        prod.NONTAXABLE =
          prod.AMOUNT -
          prod.DISCOUNT +
          this.nullToZeroConverter(prod.SERVICETAX);
        prod.NCRATE = prod.RATE * prod.EXRATE;
        // if (prod.REALQTY_IN == 0)
        // { prod.NCRATE = prod.PRATE; }
        // else
        // { prod.NCRATE = prod.NONTAXABLE / this.nullToZeroConverter(prod.REALQTY_IN); }
      }
      prod.NETAMOUNT =
        this.nullToZeroConverter(prod.TAXABLE) +
        this.nullToZeroConverter(prod.NONTAXABLE) +
        this.nullToZeroConverter(prod.SERVICETAX) +
        this.nullToZeroConverter(prod.VAT);
      TrnMainObj.TOTAMNT += prod.AMOUNT;
      TrnMainObj.TOTALINDDISCOUNT += this.nullToZeroConverter(prod.INDDISCOUNT);
      TrnMainObj.TOTALLOYALTY += this.nullToZeroConverter(prod.LOYALTY);
      TrnMainObj.TOTALPROMOTION += this.nullToZeroConverter(prod.PROMOTION);
      TrnMainObj.DCAMNT += this.nullToZeroConverter(prod.DISCOUNT);
      TrnMainObj.ServiceCharge += this.nullToZeroConverter(prod.SERVICETAX);
      TrnMainObj.TAXABLE += this.nullToZeroConverter(prod.TAXABLE);
      TrnMainObj.NONTAXABLE += this.nullToZeroConverter(prod.NONTAXABLE);
      TrnMainObj.VATAMNT += this.nullToZeroConverter(prod.VAT);
      TrnMainObj.NETWITHOUTROUNDOFF += this.nullToZeroConverter(prod.NETAMOUNT);
    });

    TrnMainObj.NETAMNT = Math.round(
      this.nullToZeroConverter(TrnMainObj.NETWITHOUTROUNDOFF)
    );
    TrnMainObj.ROUNDOFF = TrnMainObj.NETAMNT - TrnMainObj.NETWITHOUTROUNDOFF;
    TrnMainObj.TotalWithIndDiscount = 0;
    TrnMainObj.ProdList.forEach((x) => {
      TrnMainObj.TotalWithIndDiscount += this.nullToZeroConverter(x.TOTAL);
    });
    return TrnMainObj;
  }

  nullToZeroConverter(value: any) {
    if (value == undefined || value == null) {
      return 0;
    }
    return +value;
  }

  ischeckReturnQuantityError(prod: TrnProd): boolean {
    try {
      var pr = this.cnReturnedProdList.find((itm) => itm.MCODE == prod.MCODE);
      if (!pr) {
        //there is no such product in return list
        return true;
      }
      console.log({ checkreturn: prod });
      let prodarray: TrnProd[] = [];
      this.cnReturnedProdList.forEach((prd) => {
        var p: any;

        if (prodarray.length > 0) {
          p = prodarray.find((res) => res.MCODE == prd.MCODE);
        }
        if (p) {
          p.Quantity += prd.Quantity;
          p.REALQTY_IN += prd.REALQTY_IN;
          if (prd.RATE > p.RATE) {
            p.RATE = prd.RATE;
          }
        } else {
          prodarray.push(prd);
        }
      });
      var tProd = prodarray.find((prd) => prd.MCODE == prod.MCODE);
      if (tProd) {
        if (prod.Quantity > tProd.Quantity) {
          return true;
        }
        if (prod.RATE > tProd.RATE) {
          return true;
        }
      }

      return false;
    } catch (ex) {
      console.log({ CheckreturnError: ex });
      return false;
    }
  }

  resetData() {
    this.TrnMainObj.TRNAC = '';
    this.TrnMainObj.PARAC = '';
    this.TrnMainObj.BILLTO = '';
    this.TrnMainObj.BILLTOADD = '';
    this.TrnMainObj.BILLTOMOB = '';
    this.TrnMainObj.BILLTOTEL = '';
    this.TrnMainObj.ProdList = [];
  }
  a = [
    '',
    'One ',
    'Two ',
    'Three ',
    'Four ',
    'Five ',
    'Six ',
    'Seven ',
    'Eight ',
    'Nine ',
    'Ten ',
    'Eleven ',
    'Twelve ',
    'Thirteen ',
    'Fourteen ',
    'Fifteen ',
    'Sixteen ',
    'Seventeen ',
    'Eighteen ',
    'Nineteen ',
  ];
  b = [
    '',
    '',
    'Twenty',
    'Thirty',
    'Forty',
    'Fifty',
    'Sixty',
    'Seventy',
    'Eighty',
    'Ninety',
  ];

  decimalToWord(frac: any) {
    if (parseInt(frac[1]) != 0) {
      return (
        (this.a[Number(frac[1])] ||
          this.b[frac[1][0]] + ' ' + this.a[frac[1][1]]) + 'Paisa Only '
      );
    } else {
      return '';
    }
  }
  digitToWord(num: any) {}
  // digitToWord(num: any) {
  //   if (num != null && num != '' && num != undefined) {
  //     var nums = num.toString().split('.');
  //     var whole = nums[0];
  //     let w = ('000000000' + whole)
  //       .substr(-9)
  //       .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  //     if ((whole = whole.toString()).length > 9) return 'Overflow';
  //     if (nums.length == 2) {
  //       var wholeFraction = nums[1];
  //       var fraction = wholeFraction.substring(0, 2);
  //       if (
  //         fraction == '1' ||
  //         fraction == '2' ||
  //         fraction == '3' ||
  //         fraction == '4' ||
  //         fraction == '5' ||
  //         fraction == '6' ||
  //         fraction == '7' ||
  //         fraction == '8' ||
  //         fraction == '9'
  //       ) {
  //         fraction = fraction + '0';
  //       } else if (
  //         fraction == '01' ||
  //         fraction == '02' ||
  //         fraction == '03' ||
  //         fraction == '04' ||
  //         fraction == '05' ||
  //         fraction == '06' ||
  //         fraction == '07' ||
  //         fraction == '08' ||
  //         fraction == '09'
  //       ) {
  //         fraction = '09';
  //         fraction = fraction.substring(1, 2);
  //       }
  //       let f = ('00' + fraction).substr(-2).match(/^(\d{2})$/);

  //       if (!w || !f) return;
  //       var str = '';
  //       str +=
  //         parseInt(w[1]) != 0
  //           ? (this.a[Number(w[1])] ||
  //               this.b[w[1][0]] + ' ' + this.a[w[1][1]]) + 'Crore '
  //           : '';
  //       str +=
  //         parseInt(w[2]) != 0
  //           ? (this.a[Number(w[2])] ||
  //               this.b[w[2][0]] + ' ' + this.a[w[2][1]]) + 'Lakh '
  //           : '';
  //       str +=
  //         parseInt(w[3]) != 0
  //           ? (this.a[Number(w[3])] ||
  //               this.b[w[3][0]] + ' ' + this.a[w[3][1]]) + 'Thousand '
  //           : '';
  //       str +=
  //         parseInt(w[4]) != 0
  //           ? (this.a[Number(w[4])] ||
  //               this.b[w[4][0]] + ' ' + this.a[w[4][1]]) + 'Hundred '
  //           : '';
  //       str +=
  //         parseInt(w[5]) != 0
  //           ? (this.a[Number(w[5])] ||
  //               this.b[w[5][0]] + ' ' + this.a[w[5][1]]) +
  //             'and ' +
  //             this.decimalToWord(f)
  //           : '';
  //       return str;
  //     } else {
  //       if (!w) return;
  //       var str = '';
  //       str +=
  //         parseInt(w[1]) != 0
  //           ? (this.a[Number(w[1])] ||
  //               this.b[w[1][0]] + ' ' + this.a[w[1][1]]) + 'Crore '
  //           : '';
  //       str +=
  //         parseInt(w[2]) != 0
  //           ? (this.a[Number(w[2])] ||
  //               this.b[w[2][0]] + ' ' + this.a[w[2][1]]) + 'Lakh '
  //           : '';
  //       str +=
  //         parseInt(w[3]) != 0
  //           ? (this.a[Number(w[3])] ||
  //               this.b[w[3][0]] + ' ' + this.a[w[3][1]]) + 'Thousand '
  //           : '';
  //       str +=
  //         parseInt(w[4]) != 0
  //           ? (this.a[Number(w[4])] ||
  //               this.b[w[4][0]] + ' ' + this.a[w[4][1]]) + 'Hundred '
  //           : '';
  //       str +=
  //         parseInt(w[5]) != 0
  //           ? (this.a[Number(w[5])] ||
  //               this.b[w[5][0]] + ' ' + this.a[w[5][1]]) + 'Only '
  //           : '';
  //       return str;
  //     }
  //   }
  // }
}

export interface ProdListMode {
  mode: string;
  selectedRow: TrnMain;
}
